import React from 'react';
import { inject, observer } from "mobx-react";
import { VariationsType } from './variationsType';
import { Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const byPrimary = (a, b) => {
    if (a.isPrimary) return -1;
    if (b.isPrimary) return 1;
    return 0;
};

@inject('currentItem')
@observer
export class VariationTypesSection extends React.Component {
    onAdd = () => this.props.currentItem.addVariationsType();
    onDelete = (id) => this.props.currentItem.removeVariationsType(id);
    onMakePrimary = (id) => this.props.currentItem.setPrimaryVariationsType(id);

    render() {
        return (
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                {this.props.currentItem.variationsTypes.slice().sort(byPrimary).map(variationsType => (
                    <VariationsType
                        key={variationsType.id}
                        variationsType={variationsType}
                        onDelete={this.onDelete}
                        onMakePrimary={this.onMakePrimary}
                    />
                ))}
                <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={this.onAdd}
                >
                    Add Variation Type
                </Button>
            </Space>
        );
    }
}
